import { http } from './http'
import type { Contact } from '../store/contacts/contacts.types'

export const getContacts = async (): Promise<Contact[]> => {
  const { data } = await http.get<Contact[]>(`/v2/contacts`)
  return data
}
